import { Link } from "react-router-dom";
import type { Video } from "@/mocks/videos";

interface LatestShortsProps {
  videos: Video[];
}

export default function LatestShorts({ videos }: LatestShortsProps) {
  if (videos.length === 0) return null;

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="flex items-end justify-between gap-4 mb-6 flex-wrap">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 flex items-center gap-2">
            <span className="w-1.5 h-6 rounded-full bg-secondary-500"></span>
            最新上线
          </h2>
          <p className="text-sm text-foreground-600 mt-2">按上线时间倒序，第一时间看到新作</p>
        </div>
        <Link to="/category/short" className="text-sm text-primary-600 font-medium flex items-center gap-1 hover:text-primary-700 cursor-pointer whitespace-nowrap">
          更多短视频 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {videos.map((video) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group flex gap-4 bg-background-50 border border-background-200/80 rounded-lg p-3 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div className="relative w-28 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
              <img
                src={video.cover}
                alt={`${video.title}封面`}
                title={`${video.title} - 69视频`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="flex flex-col flex-1 min-w-0">
              <span className="text-xs font-medium text-secondary-600 mb-1">{video.genres.join(" · ")}</span>
              <h3 className="font-semibold text-base text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {video.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1.5">{video.year} · {video.region} · {video.duration}</p>
              <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed mt-2">{video.summary}</p>
              <div className="mt-auto pt-2 flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1 text-accent-600 font-semibold">
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  {video.rating.toFixed(1)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  {video.popularity}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}